import clsx from 'clsx';
import React from 'react';
import { BoldSubtitle } from 'components/Text';
import useStyles from './InfoRowStyles';
export default function InfoRow({
  primary,
  secondary,
  dense
}) {
  const {
    listItem,
    listItemTitle,
    listItemSubtitle,
    listItemDense
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(listItem, {
      [listItemDense]: dense
    })
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: listItemTitle
  }, primary), /*#__PURE__*/React.createElement(BoldSubtitle, {
    className: listItemSubtitle
  }, secondary));
}
InfoRow.defaultProps = {
  dense: false,
  secondary: undefined
};